import React from 'react';
import TableBlock from './TableBlock';

const BlockComponent = ({
  props,
  valueHeader,
  valueHeader2,
  valueFind,
  leftRight,
  hpi_conditions,
  medications,
  vitalSigns,
  is_null
}) => {
  const entity = props.contentState.getEntity(props.block.getEntityAt(0));
  const type = entity.getType();
  if (type == 'TABLE') {
    return (
      <TableBlock
        is_null={is_null}
        medications={medications || null}
        vitalSigns={vitalSigns || null}
        valueHeader2={valueHeader2}
        valueHeader={valueHeader}
        valueFind={valueFind}
        hpi_conditions={hpi_conditions}
        blockProps={props.blockProps}
        block={props.block}
        contentState={props.contentState}
        leftRight={leftRight}
      />
    );
  }
  return null;
};

export default BlockComponent;
